import { Directive, Input, input } from '@angular/core';

import { cn } from '@valk-nx/core/lib/core';

@Directive({
	selector: '[sbRoot]',
	standalone: false,
})
export class StoryblokRootDirective {
	@Input() _editable!: string;
	@Input() _uid!: string;
	@Input() component!: string;

	@Input() canonical!: string;
	@Input() robotsNoIndex!: boolean;
	@Input() robotsNoFollow!: boolean;

	// Needed to "mute" errors in console
	metaDescription = input<string>('');
	metaTitle = input<string>('');

	cn = cn;
}
